export const PauseIcon = () => (
	<svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="30.5" cy="30" r="29.5" fill="white" stroke="#F2A93D" />
		<rect
			x="19.1074"
			y="19.2111"
			width="7.78577"
			height="21.5779"
			rx="3.89288"
			fill="#FEF8ED"
			stroke="#F2A93D"
			strokeWidth="4"
		/>
		<rect
			x="34.1074"
			y="19.2111"
			width="7.78577"
			height="21.5779"
			rx="3.89288"
			fill="#FEF8ED"
			stroke="#F2A93D"
			strokeWidth="4"
		/>
	</svg>
);
